import RaisedButton from '@guestyci/foundation/RaisedButton';
import createStyles from '@guestyci/foundation/createStyles';
import { darken } from '@guestyci/foundation/theme/utils';
import defaultTheme from '@guestyci/foundation/theme/defaultTheme';

const useStyles = createStyles((theme: typeof defaultTheme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.success.default,
    boxShadow: 'none',
    borderRadius: '34px',
    lineHeight: 1.35,
    padding: '19px 112px',
    '&:not([disabled]):hover': {
      backgroundColor: darken(theme.palette.success.default, 0.1),
    },
    '&:disabled': {
      backgroundColor: darken(theme.palette.success.default, 0.1),
    },
  },
}));

interface IFormButton {
  children: React.ReactNode;
  isLoading?: boolean;
  disabled?: boolean;
  onSubmit?: () => void;
}

export default function FormButton({
  children,
  isLoading,
  disabled,
  onSubmit,
}: IFormButton) {
  const classes = useStyles();

  return (
    <div className="bg-transparent border-0 w-fill">
      <RaisedButton
        className={classes.root}
        isLoading={isLoading}
        disabled={disabled}
        onClick={onSubmit}
        type="submit"
      >
        {children}
      </RaisedButton>
    </div>
  );
}
